import { trackEvent } from '../../lib/analytics';

const PhoneIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
  </svg>
);

const PHONES: Array<{ label: string; tel: string }> = [
  { label: '05 22 93 04 08', tel: '0522930408' },
  { label: '06 61 25 04 82', tel: '0661250482' },
  { label: '06 70 34 79 10', tel: '0670347910' },
  { label: '06 61 46 20 57', tel: '0661462057' },
];

const Contact = () => (
  <section className="ppb-contact" id="contact">
    <div className="container">
      <div className="ppb-contact-card">
        <h2 className="ppb-contact-title">Une question ? Appelez-nous.</h2>
        <p className="ppb-contact-sub">GS Sanaa, Casablanca — Maroc</p>
        <div className="ppb-contact-phones">
          {PHONES.map((p) => (
            <a
              key={p.tel}
              href={`tel:${p.tel}`}
              className="ppb-contact-phone"
              onClick={() => trackEvent('outbound_click', { target: 'phone', page: 'prepa-post-bac' })}
            >
              <PhoneIcon />
              {p.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
